import { findConnectionAppBySlug } from '@/data/connectionAppsCatalog'
import { ICON_URL_BY_SLUG } from './workflowAppIconsData.js'
import { slugFromDisplayName } from './slugFromDisplayName.js'

/** @param {string} displayName */
export function resolveWorkflowAppIcon(displayName) {
  const pillKind = slugFromDisplayName(displayName)
  const catalog = findConnectionAppBySlug(pillKind)
  if (catalog?.icon) {
    return { displayName, iconUrl: catalog.icon, pillKind }
  }
  const iconUrl = ICON_URL_BY_SLUG[pillKind] ?? null
  return { displayName, iconUrl, pillKind }
}
